import AppSpinner from './AppSpinner';

export default AppSpinner;
